import React, { useState, useEffect, useCallback } from "react";
import DocumentsToRequireDetailsView from "./documents-to-require-details.view";
import DocumentsToRequireAddDocumentView from "./documents-to-require-add-new-document.view";
import moment from "moment";
import { ClientDocument } from "../../../../services";
import { useTranslation } from "react-i18next";

const DocumentsToRequireConfigurationView = ({
  selectedUser,
  selectedValueFilter,
  toggleCompletedRequesting,
  toggleLoadingRequesting,
  toggleErrorRequesting,
  nameComponentUser,
  token,
  setHeaderTitleinDetail,
  validators,
  toggleDialogYesNo,
  showDialogYesNo,
  clientId,
  typeDocuments,
  preferenceValue,
  handleFile,
  handleDeleteFile,
  selectedFile,
  selectedFileName,
  errorFile,
  selectedFileBase64,
  colorBorderContainer,
  newOptions,
  handleChangePage,
  deleteClientDocument,
  personTypes,
  createClientDocument,
  updateClientDocument,
  language
}) => {
  const [stateNameComponentUser, setStateNameComponentUser] = useState("");
  const [showLoadingRequesting, setShowLoadingRequesting] = useState(false);
  const [showErrorRequesting, setShowErrorRequesting] = useState(false);
  const [showDetailComponent, setShowComponentDetail] = useState(false);
  const [showCompletedRequesting, setShowCompletedRequesting] = useState(false);
  const { t } = useTranslation()

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    setStateNameComponentUser(nameComponentUser);
  }, [nameComponentUser]);

  useEffect(() => {
    renderComponentUser();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [stateNameComponentUser]);

  const renderComponentUser = useCallback(() => {
    switch (stateNameComponentUser) {
      case t("documentsToRequire.grid.detail"):
      case t("documentsToRequire.newDocument"):
        return (
          <DocumentsToRequireAddDocumentView
            selectedUser={selectedUser}
            selectedValueFilter={selectedValueFilter}
            handleChangePage={handleChangePage}
            validators={validators}
            token={token}
            setHeaderTitleinDetail={setHeaderTitleinDetail}
            setStateNameComponentUser={setStateNameComponentUser}
            toggleErrorRequesting={toggleErrorRequesting}
            toggleLoadingRequesting={toggleLoadingRequesting}
            toggleCompleteRequesting={toggleCompletedRequesting}
            createClientDocument={createClientDocument}
            setShowLoadingRequesting={setShowLoadingRequesting}
            setShowCompletedRequesting={setShowCompletedRequesting}
            setShowErrorRequesting={setShowErrorRequesting}
            showLoadingRequesting={showLoadingRequesting}
            showErrorRequesting={showErrorRequesting}
            showCompletedRequesting={showCompletedRequesting}
            clientId={clientId}
            typeDocuments={typeDocuments}
            preferenceValue={preferenceValue}
            handleFile={handleFile}
            handleDeleteFile={handleDeleteFile}
            selectedFile={selectedFile}
            selectedFileName={selectedFileName}
            errorFile={errorFile}
            selectedFileBase64={selectedFileBase64}
            colorBorderContainer={colorBorderContainer}
            newOptions={newOptions}
            personTypes={personTypes}
            nameComponentUser={nameComponentUser}
            updateClientDocument={updateClientDocument}
            toggleDialogYesNo={toggleDialogYesNo}
            language={language}
          />
        );
      default:
        return;
    }
  }, [
    stateNameComponentUser,
    selectedUser,
    deleteClientDocument,
    toggleCompletedRequesting,
    toggleErrorRequesting,
    toggleLoadingRequesting,
    toggleDialogYesNo,
    setHeaderTitleinDetail,
    token,
    showLoadingRequesting,
    showDetailComponent,
    showDialogYesNo,
    validators,
    updateClientDocument,
    showCompletedRequesting,
  ]);

  return <>{renderComponentUser()}</>;
};

export default DocumentsToRequireConfigurationView;

